// Для использования в формах поиска по id
import React, { SyntheticEvent } from "react";
import { Form, Input, Tooltip } from "antd";
import type { ValidatorRule } from "rc-field-form/lib/interface";
import { classNames } from "../../../lib/utils";
import "./FormItemInputId.less";

interface ComponentProps {
  name: string;
  label?: string;
  required?: boolean;
  allowClear?: boolean;
  className?: string;
  errorMessage?: string;
  placeholder?: string;
  disabled?: boolean;
  visibleTooltip?: boolean;
}

export const FormItemInputId = (props: ComponentProps) => {
  const {
    required,
    errorMessage = "",
    allowClear,
    label,
    className,
    name,
    placeholder,
    disabled,
    visibleTooltip,
  } = props;

  const customClassName = classNames(["formItem-inputId", className]);

  // Валидатор ввода
  const validationRule: ValidatorRule = {
    validator: (x, value) => {
      if (value && /[^0-9,]/.test(value)) {
        return Promise.reject();
      }
      return Promise.resolve();
    },
    message: "В качестве разделителя может использоваться только запятая",
  };

  // Преобразование строки ID в массив для записи в form
  const getValueFromEvent = (e: SyntheticEvent<HTMLInputElement, Event>) => {
    if (e.target instanceof HTMLInputElement) {
      const { value } = e.target;
      if (value) {
        return value.split(",");
      }
      return undefined;
    }
    return undefined;
  };

  const title = visibleTooltip ? "Введите ID предложений через ','" : "";

  return (
    <Tooltip title={title} mouseLeaveDelay={0}>
      <Form.Item
        label={label}
        name={name}
        className={customClassName}
        rules={[
          {
            required,
            message: errorMessage,
          },
          validationRule,
        ]}
        getValueFromEvent={getValueFromEvent}
      >
        <Input allowClear={allowClear} placeholder={placeholder} disabled={disabled} />
      </Form.Item>
    </Tooltip>
  );
};
